import React from "react";

import { Button, UncontrolledTooltip } from "reactstrap";

// emoji picker
import Picker from "emoji-picker-react";

interface StartButtonsProps {
  onToggle: () => void;
  onToggleTemplate: () => void;

  onEmojiClick: any;
  emojiPicker: any;
  setemojiPicker: any;
}

const StartButtons = ({ onToggle, onToggleTemplate, onEmojiClick, emojiPicker, setemojiPicker }: StartButtonsProps) => {

  return (
    <div className="chat-input-links me-md-2">
      <div className="links-list-item" id="more-menu">
        <Button
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect"
          onClick={onToggle}
          color="none"
        >
          <i className="bx bx-dots-horizontal-rounded align-middle"></i>
        </Button>
      </div>
      <UncontrolledTooltip target="more-menu" placement="top"
        transition={{ timeout: 1 }}
        delay={0}
      >
        Mais
      </UncontrolledTooltip>

      <div className="links-list-item" id="template">
        <Button
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect emoji-btn"
          id="template-btn"
          color="none"
          onClick={onToggleTemplate}
        >
          <i className="bx bx-file align-middle"></i>
        </Button>
      </div>
      <UncontrolledTooltip target="template" placement="top"
        transition={{ timeout: 1 }}
        delay={0}
      >
        Template
      </UncontrolledTooltip>


      {emojiPicker && <Picker onEmojiClick={onEmojiClick} width={350} height={382} />}
      <div className="links-list-item" id="emoji">
        <Button
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect emoji-btn"
          id="emoji-btn"
          color="none"
          onClick={() => setemojiPicker(!emojiPicker)}
        >
          <i className="bx bx-smile align-middle"></i>
        </Button>
      </div>
      <UncontrolledTooltip target="emoji" placement="top"
        transition={{ timeout: 1 }}
        delay={0}
      >
        Emoji
      </UncontrolledTooltip>
    </div>
  );
};

export default StartButtons;
